<form [formGroup]="form">
  <div class="row">
    <div class="col-md-12">
      <bs-ng-map           
        formControlName="Location"
        identifier="Location"
        key="UserProfile.Location"
        name="Location">
      </bs-ng-map>
    </div>
  </div>
</form>